import { PogoReportDataService } from '../pogoReportDataService';
import { autoinject } from 'aurelia-framework';
import { Subject, takeUntil } from '../../../rxjs-local';
import { BalanceReportViewModel } from '@dynamik/common/clients/reporting-clients';

@autoinject
export class BalanceSheetReport {
  constructor(private pogoReportDataService: PogoReportDataService) { }

  data: BalanceReportViewModel;
  loading: boolean;
  error: Error;
  destroy$ = new Subject<void>();

  subscribe() {
    this.pogoReportDataService.loading$.pipe(takeUntil(this.destroy$)).subscribe(loading => this.loading = loading);
    this.pogoReportDataService.data$.pipe(takeUntil(this.destroy$))
      .subscribe(x => {
        if (x instanceof Error) {
          this.error = x;
        } else {
          this.error = undefined;
          this.data = x;
        }
      });
  }

  attached() {
    this.subscribe();
  }

  detached() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
